import React, { useState } from 'react';
import { Link } from 'react-router-dom';

// Shown (centrally, from AdminLayout) when a scoped admin reaches a section
// their role/overrides don't allow — e.g. by typing the URL. Friendlier than a
// raw 403, and offers to ask a super_admin for access.
export default function NoAccess({ perm, section }) {
  const [sent, setSent] = useState(false);
  const [busy, setBusy] = useState(false);

  const requestAccess = async () => {
    setBusy(true);
    try {
      const token = localStorage.getItem('admin_token') || localStorage.getItem('adminToken');
      const r = await fetch('/api/admin/access-requests', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', ...(token ? { Authorization: `Bearer ${token}` } : {}) },
        body: JSON.stringify({ perm, section: section || (typeof window !== 'undefined' ? window.location.pathname : '') }),
      });
      if (r.ok) setSent(true);
    } catch (_) { /* best-effort */ }
    setBusy(false);
  };

  return (
    <div style={{ maxWidth: 520, margin: '64px auto', textAlign: 'center', padding: 24 }}>
      <div style={{ fontSize: 40, marginBottom: 12 }} aria-hidden="true">🔒</div>
      <h1 style={{ marginBottom: 8 }}>No access to this section</h1>
      <p style={{ color: 'var(--text-light, #64748b)', marginBottom: 20 }}>
        Your role doesn’t include this area{perm ? ` (${perm})` : ''}. Ask a super-admin to grant
        it under <strong>Team → Custom view</strong>.
      </p>
      <div style={{ display: 'flex', gap: 8, justifyContent: 'center', flexWrap: 'wrap' }}>
        <Link to="/admin" className="btn btn-primary">Back to dashboard</Link>
        {sent ? (
          <span style={{ color: 'var(--color-success-dark, #137333)', alignSelf: 'center' }}>✓ Request sent</span>
        ) : (
          <button className="btn" onClick={requestAccess} disabled={busy}>
            {busy ? 'Sending…' : 'Request access'}
          </button>
        )}
      </div>
    </div>
  );
}
